import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { AuthProvider } from "./context/AuthContext"
import { LanguageProvider } from "./context/LanguageContext"
import { NotificationProvider } from "./context/NotificationContext"
import PrivateRoute from "./components/routing/PrivateRoute"
import AdminRoute from "./components/routing/AdminRoute"
import Navbar from "./components/layout/Navbar"
import Footer from "./components/layout/Footer"
import Home from "./pages/Home"
import Login from "./pages/Login"
import Register from "./pages/Register"
import ForgotPassword from "./pages/ForgotPassword"
import VerifyEmail from "./pages/VerifyEmail"
import Dashboard from "./pages/Dashboard"
import Profile from "./pages/Profile"
import AddFarm from "./pages/AddFarm"
import DeviceData from "./pages/DeviceData"
import ETrefHistory from "./pages/ETrefHistory"
import AdminDashboard from "./pages/admin/Dashboard"
import MasterData from "./pages/admin/MasterData"
import WeatherDataManagement from "./pages/admin/WeatherDataManagement"
import UserManagement from "./pages/admin/UserManagement"
import SystemManagement from "./pages/admin/SystemSettings"
import CalculationsManagement from "./pages/admin/CalculationsManagement"
import CropManagement from "./pages/CropManagement"
import KcCalculator from "./pages/KcCalculator"
import AddProject from "./pages/AddProject"
import ProjectDetails from "./pages/ProjectDetails"
import FarmDetails from "./pages/FarmDetails"
import UserDetails from "./pages/admin/UserDetails"
import ProjectKcCalculator from "./pages/ProjectKcCalculator"
import AboutUs from "./pages/AboutUs"
import Contact from "./pages/Contact"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import TermsOfService from "./pages/TermsOfService"
import FarmManagement from "./pages/FarmManagement"
import "./App.css"
import ProjectManagement from "./pages/ProjectManagement"
import EditFarm from "./pages/EditFarm"
import Group from "./pages/Group"
import GroupManagement from "./pages/GroupManagement"
import GroupDetails from "./pages/GroupDetails"
import EditGroup from "./pages/EditGroup"
import EditProject from "./pages/EditProject"

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <NotificationProvider>
          <Router>
            <div className="app-container">
              <Navbar />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<AboutUs />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsOfService />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/verify-email/:token" element={<VerifyEmail />} />
                  <Route
                    path="/dashboard"
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/crops"
                    element={
                      <PrivateRoute>
                        <CropManagement />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/add-project"
                    element={
                      <PrivateRoute>
                        <AddProject />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/projects/:id"
                    element={
                      <PrivateRoute>
                        <ProjectDetails />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/projects/:id/edit"
                    element={
                      <PrivateRoute>
                        <EditProject />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/projects"
                    element={
                      <PrivateRoute>
                        <ProjectManagement />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/farms/:id/edit"
                    element={
                      <PrivateRoute>
                        <EditFarm />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="projects/:pid/kc-calculator/:id"
                    element={
                      <PrivateRoute>
                        <KcCalculator />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="projects/:id/kc-calculator-curve/:id"
                    element={
                      <PrivateRoute>
                        <ProjectKcCalculator />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/add-farm"
                    element={
                      <PrivateRoute>
                        <AddFarm />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/farm-management"
                    element={
                      <PrivateRoute>
                        <FarmManagement />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/farms/:id"
                    element={
                      <PrivateRoute>
                        <FarmDetails />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/admin/calculations"
                    element={
                      <AdminRoute>
                        <CalculationsManagement />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/group"
                    element={
                      <PrivateRoute>
                        <Group></Group>
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/device-data"
                    element={
                      <PrivateRoute>
                        <DeviceData />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/etref-history"
                    element={
                      <PrivateRoute>
                        <ETrefHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/admin"
                    element={
                      <AdminRoute>
                        <AdminDashboard />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/calculations"
                    element={
                      <AdminRoute>
                        <CalculationsManagement />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/weather"
                    element={
                      <AdminRoute>
                        <WeatherDataManagement />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/master-data"
                    element={
                      <AdminRoute>
                        <MasterData />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/users"
                    element={
                      <AdminRoute>
                        <UserManagement />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/users/:userId"
                    element={
                      <AdminRoute>
                        <UserDetails />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/system"
                    element={
                      <AdminRoute>
                        <SystemManagement />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/groups"
                    element={
                      <PrivateRoute>
                        <GroupManagement />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/groups/:id"
                    element={
                      <PrivateRoute>
                        <GroupDetails />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/groups/:id/edit"
                    element={
                      <PrivateRoute>
                        <EditGroup />
                      </PrivateRoute>
                    }
                  />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </NotificationProvider>
      </LanguageProvider>
    </AuthProvider>
  )
}

export default App
